import React from 'react';
import PropTypes from 'prop-types';

import CustomModal from '../custom_modal';
import PayTimeWarningStep from './index';
import { DETAIL_EFFECT, DETAIL_TIME } from './pay_time_warning_rules';

// For class-component pages: the warning step as the dialog's next screen. The host closes its form
// dialog, keeps its field values, and reopens it on Change.
export default function PayTimeWarningModal({
  warning,
  title,
  detail,
  busy,
  changeLabel,
  onAcknowledge,
  onChange,
  onClose
}) {
  return (
    <CustomModal show={!!warning} close={onClose} variant="form">
      <h5>{title}</h5>
      {warning ? (
        <PayTimeWarningStep
          warning={warning}
          detail={detail}
          busy={busy}
          changeLabel={changeLabel}
          onAcknowledge={onAcknowledge}
          onChange={onChange}
        />
      ) : null}
    </CustomModal>
  );
}

PayTimeWarningModal.propTypes = {
  warning: PropTypes.shape({ warnings: PropTypes.arrayOf(PropTypes.string) }),
  title: PropTypes.string.isRequired,
  detail: PropTypes.oneOf([DETAIL_TIME, DETAIL_EFFECT]),
  busy: PropTypes.bool,
  changeLabel: PropTypes.string,
  onAcknowledge: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired
};

PayTimeWarningModal.defaultProps = {
  warning: null,
  detail: DETAIL_TIME,
  busy: false,
  changeLabel: 'Change'
};
